import styled from 'styled-components';
import Typography from '../../commonComponents/Typography/Typography';
import Box from '../../layoutComponents/Box';

export const TooltipContent = styled(Typography).attrs(() => ({
  kind: 'body2'
}))`
  margin: 16px;
`;

export const TooltipIcon = styled(Box)`
  color: ${props => props.theme.colors.form.input.border.focus};
  margin-left: ${props => props.theme.space[2]}px;
`;
